import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Data Sources',
  content: `
Data sources in Pliable are external data repositories, such as databases, CSV files, or cloud data warehouses (e.g., Snowflake). These serve as the starting point for building your data model in the semantic layer. Connecting a data source allows Pliable to import raw data, which can then be cleaned, modeled, and analyzed.

# Adding a Data Source

To add a new data source, navigate to **Data Sources** and choose from the available options. You can either upload a **Flat File** or connect your existing **Snowflake Table**. Then, follow the necessary connection details and preview a sample of your data. If it looks good, you can click on **"Looks Good"**. Finally, you can name and describe your data source and Pliable will automatically build out your source node.

# Supported Data Sources

Pliable supports a variety of data sources including:

- **Flat Files** (CSV, Excel)
- **Snowflake Tables**
- **Connected Sources** via third-party connectors

# Data Source Nodes

Data source Nodes contain the raw data we've extracted from your Snowflake instance. We'll let you know how many rows we found and how recently we've checked for new records.

Configure your data source in the **Configure** tab. Pliable needs to know the primary or unique key for your table so we know how to search for new records.

We'll also need you to set the **Last Modified Column** with a date field so Pliable can recognize when a record has been updated.

> 📎  Your primary key can be a single field or you can use multiple fields to create a composite key.

There are two tabs in the detail view in the center of the screen. The **View Data** tab shows you the raw data we've extracted from your source data. Click on column headers to sort the table or use the Search bar at the top right of your screen to find a particular value.

> 📎  You can sort your data by multiple columns. Click on a column header to set the main sort, then hold ctrl and click a secondary sorting column header.
`,
};

export default doc;
